import { optionColor, LIFECYCLE_OPTIONS } from '../lib/format.js'
import { contactsToCsv, exportFilename } from '../lib/csv.js'
import { DataTable, Chip, Avatar, Page, PageHeader, Eyebrow, Button } from '../ds/index.js'

export default function ContactsView({ contacts = [], companiesById = {}, usersById = {}, onOpen, onCreate }) {
  // Register item 11: export the address book. Kaycia also floated emailing
  // several clients at once — deliberately NOT built. Bulk send carries
  // deliverability, unsubscribe and privacy consequences that belong in a real
  // email tool, and the export very likely covers the actual need.
  // Browser-only: the CSV itself is built by the pure helpers in lib/csv.js.
  const exportCsv = () => {
    if (typeof window === 'undefined') return
    const url = URL.createObjectURL(new Blob([contactsToCsv(contacts, companiesById)], { type: 'text/csv;charset=utf-8' }))
    const a = document.createElement('a')
    a.href = url
    a.download = exportFilename('contacts')
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  }

  const columns = [
    {
      key: 'name',
      header: 'Name',
      priority: 1,
      render: (c) => `${c.firstName || ''} ${c.lastName || ''}`.trim() || '—',
    },
    {
      key: 'email',
      header: 'Email',
      priority: 2,
      render: (c) => c.email || '',
    },
    {
      key: 'company',
      header: 'Company',
      priority: 2,
      render: (c) => {
        const co = c.primaryCompanyId ? companiesById[c.primaryCompanyId] : null
        return co ? co.name : ''
      },
    },
    {
      key: 'lifecycle',
      header: 'Lifecycle',
      priority: 3,
      render: (c) =>
        c.lifecycleStage
          ? (
            <Chip color={optionColor(LIFECYCLE_OPTIONS, c.lifecycleStage)}>
              {(LIFECYCLE_OPTIONS.find((o) => o.value === c.lifecycleStage) || {}).label || c.lifecycleStage}
            </Chip>
          )
          : null,
    },
    {
      key: 'owner',
      header: 'Owner',
      priority: 3,
      render: (c) => {
        const owner = usersById[c.ownerUid]
        return owner ? <Avatar user={owner} size={24} /> : null
      },
    },
  ]

  return (
    <Page wide>
      <PageHeader
        title="Contacts"
        chip={<Eyebrow>Relationships</Eyebrow>}
        actions={(
          <>
            <Button variant="ghost" onClick={exportCsv} disabled={contacts.length === 0}>Export CSV</Button>
            <Button onClick={onCreate}>Add contact</Button>
          </>
        )}
      />
      <DataTable
        columns={columns}
        rows={contacts}
        rowKey={(c) => c.id}
        onRowClick={(c) => onOpen(c.id)}
        empty="No contacts yet."
      />
    </Page>
  )
}
